import styled from 'styled-components';

export const StyledModalEditableName = styled.input`
  overflow: hidden;
  outline: none;
  display: block;
  width: 100%;
  border: none;
  margin: ${(p) => p.theme.space[0]};
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[6]};
  box-shadow: ${(p) => p.theme.shadows.bottom};
  background-color: transparent;

  &::placeholder {
    color: ${(p) => p.theme.alias.subtle};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
